import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedOregonSuggestedGradeLevel = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add a suggested grade level"
    okText="ADD A SUGGESTED GRADE LEVEL"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose a suggested grade level:"
      queryVariables={{ typeId: FILTER_TYPE.SUGGESTED_GRADE_LEVEL.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Suggested grade level is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedOregonSuggestedGradeLevel.Item = Item;

export default RelatedOregonSuggestedGradeLevel;
